// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__FAE1Q","mobile-hide":"styles-m__mobile-hide__3v7ss","line-separater":"styles-m__line-separater__3E6dV","skip-line":"styles-m__skip-line__e-qIS"};